import { API_ROOT } from 'src/constants';
import Request, { setData, setMethod, setURL } from '../index';

export const getUserSpecificIntents = (loanId: string) =>
  Request<any>(
    setURL(`${API_ROOT}/workflow_intents/loans/${loanId}`),
    setMethod('GET')
  ).then(response => response.data);

export const updateUserSpecificIntents = (id: string, data: any) =>
  Request<any>(
    setURL(`${API_ROOT}/workflow_intents/loans/${id}`),
    setMethod('PUT'),
    setData(data)
  ).then(response => response.data);
